import numeral from "numeral";
import ReactTable from "react-table";
import { Spin } from "@biteship/atom";

export default function ImportTable(props) {
  const expressColumns = [
    {
      Header: "#",
      accessor: "No",
      Cell: ({ row, original }) => numCell(row, original),
      maxWidth: 50,
      className: "text-center",
      headerStyle: { overflow: "hidden" },
      headerClassName: "text-center",
    },
    {
      Header: "ORIGIN CITY ID",
      accessor: "Origin City Id",
      minWidth: 110,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Origin City Id"] || "-",
    },
    {
      Header: "ORIGIN DISTRICT ID",
      accessor: "Origin District Id",
      minWidth: 130,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Origin District Id"] || "-",
    },
    {
      Header: "ORIGIN POSTAL CODE",
      accessor: "Origin Postal Code",
      minWidth: 150,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Origin Postal Code"] || "-",
    },
    {
      Header: "DESTINATION CITY ID",
      minWidth: 150,
      accessor: "Destination City Id",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Destination City Id"] || "-",
    },
    {
      Header: "DESTINATION DISTRICT ID",
      minWidth: 170,
      accessor: "Destination District Id",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Destination District Id"] || "-",
    },
    {
      Header: "DESTINATION POSTAL CODE",
      minWidth: 190,
      accessor: "Destination Postal Code",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Destination Postal Code"] || "-",
    },
    {
      Header: "BASE PRICE",
      accessor: "Base Price",
      minWidth: 95,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Base Price"]),
    },
    {
      Header: "PRICE PER KG",
      minWidth: 100,
      accessor: "Price per Kg",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Price per Kg"]),
    },
    {
      Header: "PRICE PER VOLUME",
      minWidth: 140,
      accessor: "Price per Volume",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Price per Volume"]),
    },
  ];

  const instantColumns = [
    {
      Header: "#",
      accessor: "No",
      Cell: ({ row, original }) => numCell(row, original),
      maxWidth: 50,
      className: "text-center",
      headerStyle: { overflow: "hidden" },
      headerClassName: "text-center",
    },
    {
      Header: "ORIGIN LATITUDE",
      accessor: "Origin Latitude",
      minWidth: 120,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Origin Latitude"] || "-",
    },
    {
      Header: "ORIGIN LONGITUDE",
      accessor: "Origin Longitude",
      minWidth: 130,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Origin Longitude"] || "-",
    },
    {
      Header: "DESTINATION LATITUDE",
      accessor: "Destination Latitude",
      minWidth: 160,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Destination Latitude"] || "-",
    },
    {
      Header: "DESTINATION LONGITUDE",
      accessor: "Destination Longitude",
      minWidth: 170,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => row["Destination Longitude"] || "-",
    },
    {
      Header: "BASE PRICE",
      accessor: "Base Price",
      minWidth: 95,
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Base Price"]),
    },
    {
      Header: "PRICE PER KG",
      minWidth: 100,
      accessor: "Price per Kg",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Price per Kg"]),
    },
    {
      Header: "PRICE PER VOLUME",
      minWidth: 140,
      accessor: "Price per Volume",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Price per Volume"]),
    },
    {
      Header: "PRICE PER KM",
      minWidth: 110,
      accessor: "Price per Km",
      headerStyle: { overflow: "hidden" },
      Cell: ({ row, original }) => amountCell(row["Price per Km"]),
    },
  ];

  const amountCell = (og) => <div>Rp. {numeral(Math.abs(og)).format("0,0")}</div>;

  const numCell = (row, og) => {
    let num;
    if (props.loading && !og.submitted) {
      num = (
        <div className="flex justify-center">
          <Spin size="xs" />
        </div>
      );
    } else {
      num = row._index + 1;
    }

    return num;
  };

  return (
    <ReactTable
      data={props.data}
      columns={props.courierType === "express" ? expressColumns : instantColumns}
      pageSize={props.data.length > 20 ? 20 : props.data.length}
      showPagination={props.data.length > 20 ? true : false}
      showPageSizeOptions={false}
      className="-striped -highlight"
    />
  );
}
